import { useState } from "react";
import { ArrowRight, Mail, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import FormModal from "@/components/FormModal";

type CTAVariant = "newsletter" | "contact";

const InlineCTA = ({ variant = "newsletter" }: { variant?: CTAVariant }) => {
  const [formOpen, setFormOpen] = useState(false);

  if (variant === "contact") {
    return (
      <div className="rounded-lg border border-border bg-card/50 px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <MessageSquare className="w-4 h-4 text-primary shrink-0" />
          <p className="text-sm text-muted-foreground truncate">
            Want to work with us or have a question?
          </p>
        </div>
        <Link
          to="/contact"
          className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground font-semibold text-xs px-4 py-2 rounded-md hover:opacity-90 transition-opacity shrink-0"
        >
          Contact Us <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="rounded-lg border border-border bg-card/50 px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Mail className="w-4 h-4 text-primary shrink-0" />
          <p className="text-sm text-muted-foreground truncate">
            <span className="hidden sm:inline">Weekly prediction markets intelligence. Free forever.</span>
            <span className="sm:hidden">Weekly markets intel. Free.</span>
          </p>
        </div>
        <button
          onClick={() => setFormOpen(true)}
          className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground font-semibold text-xs px-4 py-2 rounded-md hover:opacity-90 transition-opacity shrink-0"
        >
          Subscribe <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>

      <FormModal
        isOpen={formOpen}
        onClose={() => setFormOpen(false)}
        title="Join the inner circle."
        subtitle="Get weekly prediction markets intelligence that the crowd does not see. Curated news, exclusive analysis, and early access to NEXTPredict research."
        incentive="🎁 Subscribers get first access to our reports, event invites, and summit ticket drops."
        formId="7e677eab-387c-4053-af96-df54a2e31344"
      />
    </>
  );
};

export default InlineCTA;
